import { useState, useEffect } from "react";
import { api } from "../../context";

export default function Wallet({ t }) {
  const [data, setData] = useState(null);
  const [tab, setTab] = useState("overview");
  const [loading, setLoading] = useState(true);

  const CARD=t.card,BORDER=t.border,TEXT=t.text,SUB=t.sub,PRI=t.pri,GRN=t.grn,RED=t.red,GOLD=t.gold;
  const fmt = (n) => Number(n || 0).toLocaleString();

  useEffect(() => {
    api("/admin/wallet-stats").then(r => {
      if (r.ok) setData(r.data);
      setLoading(false);
    });
  }, []);

  if (loading) return <div style={{ padding: 40, color: SUB, textAlign: "center" }}>⏳ Loading GT Token data...</div>;
  if (!data) return <div style={{ padding: 40, color: RED }}>Failed to load wallet data</div>;

  const ov = data.overview || {};

  const typeColors = { earn: GRN, spend: RED, transfer: PRI, reward: GOLD, purchase: "#8b5cf6", daily_login: "#06b6d4", referral: "#ec4899" };
  const typeIcons  = { earn: "📥", spend: "📤", transfer: "↔️", reward: "🎁", purchase: "💳", daily_login: "📅", referral: "👥" };

  const MiniBar = ({ items = [], color, height = 60, valueKey = "total" }) => {
    const max = Math.max(...items.map(d => d[valueKey] || 0), 1);
    return (
      <div style={{ display: "flex", alignItems: "flex-end", gap: 2, height }}>
        {items.map((d, i) => {
          const h = Math.max(2, ((d[valueKey] || 0) / max) * (height - 4));
          return <div key={i} style={{ flex: 1, height: h, background: color, borderRadius: "2px 2px 0 0", opacity: 0.85, minWidth: 3 }} title={`${d.date}: ${d[valueKey]}`} />;
        })}
      </div>
    );
  };

  const tabs = ["overview", "holders", "transactions", "transfers", "rewards"];

  return (
    <div>
      <div style={{ fontSize: 22, fontWeight: 800, color: TEXT, marginBottom: 4 }}>🪙 GT Tokens</div>
      <div style={{ fontSize: 12, color: SUB, marginBottom: 24 }}>GT Token economy — circulation, holders, transfers and rewards</div>

      {/* Overview stats */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 12, marginBottom: 20 }}>
        {[
          { label: "Total Circulating", value: fmt(ov.total_tokens_circulating), sub: `≈ KES ${fmt(ov.token_kes_value)}`, color: GOLD },
          { label: "Total Earned (All Time)", value: fmt(ov.total_earned_all_time), sub: "All rewards + purchases", color: GRN },
          { label: "Total Spent (All Time)", value: fmt(ov.total_spent_all_time), sub: "Used on platform", color: RED },
        ].map((s, i) => (
          <div key={i} style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 14, padding: "20px 24px" }}>
            <div style={{ fontSize: 10, fontWeight: 700, color: SUB, textTransform: "uppercase", letterSpacing: 1, marginBottom: 8 }}>{s.label}</div>
            <div style={{ fontSize: 28, fontWeight: 900, color: s.color }}>{s.value}</div>
            <div style={{ fontSize: 11, color: SUB, marginTop: 6 }}>{s.sub}</div>
          </div>
        ))}
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 12, marginBottom: 20 }}>
        {[
          { label: "Total Wallets", value: fmt(ov.total_wallets), color: PRI },
          { label: "Avg Balance", value: fmt(ov.avg_balance) + " GT", color: GOLD },
          { label: "Token Value", value: `1 GT = KES 1`, color: GRN },
        ].map((s, i) => (
          <div key={i} style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 12, padding: "16px 20px" }}>
            <div style={{ fontSize: 10, fontWeight: 700, color: SUB, textTransform: "uppercase", letterSpacing: 1, marginBottom: 8 }}>{s.label}</div>
            <div style={{ fontSize: 22, fontWeight: 800, color: s.color }}>{s.value}</div>
          </div>
        ))}
      </div>

      {/* Daily token chart */}
      {data.daily_tokens?.length > 0 && (
        <div style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 14, padding: "20px 24px", marginBottom: 20 }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: TEXT, marginBottom: 16 }}>📈 Daily Token Activity (30 days)</div>
          <MiniBar items={data.daily_tokens} color={GOLD} height={80} valueKey="total" />
          <div style={{ display: "flex", justifyContent: "space-between", marginTop: 6 }}>
            <span style={{ fontSize: 10, color: SUB }}>{data.daily_tokens[0]?.date?.slice(5)}</span>
            <span style={{ fontSize: 10, color: SUB }}>{data.daily_tokens[data.daily_tokens.length - 1]?.date?.slice(5)}</span>
          </div>
        </div>
      )}

      {/* Tabs */}
      <div style={{ display: "flex", gap: 8, marginBottom: 20 }}>
        {tabs.map(tb => (
          <button key={tb} onClick={() => setTab(tb)}
            style={{ padding: "8px 16px", borderRadius: 10, border: `1.5px solid ${tab === tb ? GOLD : BORDER}`, background: tab === tb ? `${GOLD}15` : "transparent", color: tab === tb ? GOLD : SUB, fontSize: 12, fontWeight: 700, cursor: "pointer", textTransform: "capitalize" }}>
            {tb}
          </button>
        ))}
      </div>

      {/* Overview tab */}
      {tab === "overview" && (
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
          {/* By type */}
          <div style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 14, padding: "20px 24px" }}>
            <div style={{ fontSize: 14, fontWeight: 700, color: TEXT, marginBottom: 16 }}>Transaction Types</div>
            {data.by_type?.map((tt, i) => {
              const color = typeColors[tt.type] || PRI;
              const icon  = typeIcons[tt.type] || "🪙";
              return (
                <div key={i} style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 0", borderBottom: i < data.by_type.length - 1 ? `1px solid ${BORDER}` : "none" }}>
                  <span style={{ fontSize: 18 }}>{icon}</span>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 13, fontWeight: 700, color: TEXT, textTransform: "capitalize" }}>{tt.type?.replace(/_/g, " ")}</div>
                    <div style={{ fontSize: 11, color: SUB }}>{fmt(tt.count)} transactions</div>
                  </div>
                  <div style={{ textAlign: "right" }}>
                    <div style={{ fontSize: 15, fontWeight: 800, color }}>{fmt(tt.total)} GT</div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Reward types */}
          <div style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 14, padding: "20px 24px" }}>
            <div style={{ fontSize: 14, fontWeight: 700, color: TEXT, marginBottom: 16 }}>🎁 Reward Sources</div>
            {!data.reward_types?.length
              ? <div style={{ textAlign: "center", padding: "24px 0", color: SUB }}>No reward data yet</div>
              : data.reward_types.map((rt, i) => {
                const color = typeColors[rt.type] || GOLD;
                return (
                  <div key={i} style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 0", borderBottom: i < data.reward_types.length - 1 ? `1px solid ${BORDER}` : "none" }}>
                    <span style={{ fontSize: 16 }}>🎁</span>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: 13, fontWeight: 700, color: TEXT, textTransform: "capitalize" }}>{rt.type?.replace(/_/g, " ")}</div>
                      <div style={{ fontSize: 11, color: SUB }}>{fmt(rt.count)} times awarded</div>
                    </div>
                    <div style={{ fontSize: 15, fontWeight: 800, color: GOLD }}>{fmt(rt.total)} GT</div>
                  </div>
                );
              })
            }
          </div>
        </div>
      )}

      {/* Holders tab */}
      {tab === "holders" && (
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 16 }}>
          {[
            { title: "🏆 Top Holders", data: data.top_holders, valueKey: "balance", color: GOLD, label: "Balance" },
            { title: "📥 Top Earners", data: data.top_earners, valueKey: "total_earned", color: GRN, label: "Earned" },
            { title: "📤 Top Spenders", data: data.top_spenders, valueKey: "total_spent", color: RED, label: "Spent" },
          ].map((section, si) => (
            <div key={si} style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 14, padding: "20px 24px" }}>
              <div style={{ fontSize: 14, fontWeight: 700, color: TEXT, marginBottom: 16 }}>{section.title}</div>
              {(section.data || []).slice(0, 10).map((u, i) => (
                <div key={i} style={{ display: "flex", alignItems: "center", gap: 10, padding: "8px 0", borderBottom: i < 9 ? `1px solid ${BORDER}` : "none" }}>
                  <span style={{ fontSize: 11, color: SUB, width: 20, fontWeight: 700 }}>{i + 1}</span>
                  <div style={{ width: 28, height: 28, borderRadius: 14, background: `linear-gradient(135deg, ${section.color}, ${PRI})`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 14 }}>{u.avatar_emoji || "👤"}</div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 12, fontWeight: 700, color: TEXT, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{u.name}</div>
                    <div style={{ fontSize: 10, color: SUB, textTransform: "capitalize" }}>{u.plan}</div>
                  </div>
                  <div style={{ fontSize: 14, fontWeight: 800, color: section.color, flexShrink: 0 }}>{fmt(u[section.valueKey])}</div>
                </div>
              ))}
            </div>
          ))}
        </div>
      )}

      {/* Transactions tab */}
      {tab === "transactions" && (
        <div style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 14, overflow: "hidden" }}>
          <div style={{ padding: "16px 24px", borderBottom: `1px solid ${BORDER}` }}>
            <div style={{ fontSize: 14, fontWeight: 700, color: TEXT }}>Recent Transactions (last 50)</div>
          </div>
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
              <thead>
                <tr style={{ background: t.hover, borderBottom: `2px solid ${BORDER}` }}>
                  {["User", "Type", "Amount", "Balance After", "Description", "Time"].map(h => (
                    <th key={h} style={{ padding: "10px 14px", textAlign: "left", fontSize: 10, fontWeight: 700, color: SUB, textTransform: "uppercase", whiteSpace: "nowrap" }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {(data.transactions || []).map((tx, i, arr) => {
                  const color = tx.amount > 0 ? GRN : RED;
                  return (
                    <tr key={tx.id} style={{ borderBottom: i < arr.length - 1 ? `1px solid ${BORDER}` : "none" }}>
                      <td style={{ padding: "10px 14px" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                          <span>{tx.owner_emoji || "👤"}</span>
                          <span style={{ fontSize: 12, fontWeight: 700, color: TEXT }}>{tx.owner_name || "Unknown"}</span>
                        </div>
                      </td>
                      <td style={{ padding: "10px 14px" }}>
                        <span style={{ padding: "2px 8px", borderRadius: 20, fontSize: 10, fontWeight: 700, background: `${typeColors[tx.type] || PRI}20`, color: typeColors[tx.type] || PRI, textTransform: "capitalize" }}>
                          {typeIcons[tx.type] || "🪙"} {tx.type?.replace(/_/g, " ")}
                        </span>
                      </td>
                      <td style={{ padding: "10px 14px", fontWeight: 800, color }}>
                        {tx.amount > 0 ? "+" : ""}{fmt(tx.amount)} GT
                      </td>
                      <td style={{ padding: "10px 14px", color: GOLD, fontWeight: 700 }}>{fmt(tx.balance_after)} GT</td>
                      <td style={{ padding: "10px 14px", color: SUB, fontSize: 12, maxWidth: 200, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{tx.description || "—"}</td>
                      <td style={{ padding: "10px 14px", color: SUB, fontSize: 11, whiteSpace: "nowrap" }}>{tx.created_at ? new Date(tx.created_at).toLocaleString() : "—"}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Transfers tab */}
      {tab === "transfers" && (
        <div style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 14, overflow: "hidden" }}>
          <div style={{ padding: "16px 24px", borderBottom: `1px solid ${BORDER}` }}>
            <div style={{ fontSize: 14, fontWeight: 700, color: TEXT }}>Account-to-Account Transfers</div>
            <div style={{ fontSize: 12, color: SUB, marginTop: 4 }}>{data.transfers?.length || 0} transfers recorded</div>
          </div>
          {!data.transfers?.length
            ? <div style={{ textAlign: "center", padding: "40px 0", color: SUB }}>No transfers yet</div>
            : (
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
                <thead>
                  <tr style={{ background: t.hover, borderBottom: `2px solid ${BORDER}` }}>
                    {["From", "To", "Amount", "Description", "Time"].map(h => (
                      <th key={h} style={{ padding: "10px 14px", textAlign: "left", fontSize: 10, fontWeight: 700, color: SUB, textTransform: "uppercase" }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {data.transfers.map((tx, i, arr) => (
                    <tr key={tx.id} style={{ borderBottom: i < arr.length - 1 ? `1px solid ${BORDER}` : "none" }}>
                      <td style={{ padding: "10px 14px" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                          <span>{tx.sender_emoji || "👤"}</span>
                          <span style={{ fontSize: 12, fontWeight: 700, color: RED }}>{tx.sender_name || "Unknown"}</span>
                        </div>
                      </td>
                      <td style={{ padding: "10px 14px" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                          <span>{tx.receiver_emoji || "👤"}</span>
                          <span style={{ fontSize: 12, fontWeight: 700, color: GRN }}>{tx.receiver_name || "Unknown"}</span>
                        </div>
                      </td>
                      <td style={{ padding: "10px 14px", fontWeight: 800, color: GOLD }}>{fmt(tx.amount)} GT</td>
                      <td style={{ padding: "10px 14px", color: SUB, fontSize: 12 }}>{tx.description || "—"}</td>
                      <td style={{ padding: "10px 14px", color: SUB, fontSize: 11 }}>{tx.created_at ? new Date(tx.created_at).toLocaleString() : "—"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )
          }
        </div>
      )}

      {/* Rewards tab */}
      {tab === "rewards" && (
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
          <div style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 14, padding: "20px 24px" }}>
            <div style={{ fontSize: 14, fontWeight: 700, color: TEXT, marginBottom: 16 }}>🎁 Reward Type Breakdown</div>
            {!data.reward_types?.length
              ? <div style={{ textAlign: "center", padding: "24px 0", color: SUB }}>No reward data yet</div>
              : data.reward_types.map((rt, i) => {
                const total = data.reward_types.reduce((a, r) => a + (r.total || 0), 0);
                const pct = total > 0 ? Math.round(rt.total / total * 100) : 0;
                return (
                  <div key={i} style={{ marginBottom: 14 }}>
                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 5 }}>
                      <span style={{ fontSize: 13, fontWeight: 600, color: TEXT, textTransform: "capitalize" }}>{rt.type?.replace(/_/g, " ")}</span>
                      <span style={{ fontSize: 13, fontWeight: 800, color: GOLD }}>{fmt(rt.total)} GT ({pct}%)</span>
                    </div>
                    <div style={{ height: 8, borderRadius: 4, background: BORDER }}>
                      <div style={{ height: 8, borderRadius: 4, background: GOLD, width: `${pct}%`, transition: "width 0.8s" }} />
                    </div>
                    <div style={{ fontSize: 10, color: SUB, marginTop: 4 }}>{fmt(rt.count)} times awarded</div>
                  </div>
                );
              })
            }
          </div>

          <div style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 14, padding: "20px 24px" }}>
            <div style={{ fontSize: 14, fontWeight: 700, color: TEXT, marginBottom: 16 }}>📊 Economy Health</div>
            {[
              { label: "Tokens in circulation", value: fmt(ov.total_tokens_circulating) + " GT", color: GOLD },
              { label: "Total ever earned", value: fmt(ov.total_earned_all_time) + " GT", color: GRN },
              { label: "Total ever spent", value: fmt(ov.total_spent_all_time) + " GT", color: RED },
              { label: "Net (earned - spent)", value: fmt(ov.total_earned_all_time - ov.total_spent_all_time) + " GT", color: PRI },
              { label: "Average balance", value: fmt(ov.avg_balance) + " GT", color: GOLD },
              { label: "KES equivalent", value: "KES " + fmt(ov.token_kes_value), color: GRN },
            ].map((s, i, arr) => (
              <div key={i} style={{ display: "flex", justifyContent: "space-between", padding: "10px 0", borderBottom: i < arr.length - 1 ? `1px solid ${BORDER}` : "none" }}>
                <span style={{ fontSize: 12, color: SUB }}>{s.label}</span>
                <span style={{ fontSize: 13, fontWeight: 800, color: s.color }}>{s.value}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}